<template>
  <div class="detail" v-loading.fullscreen.lock="planRemarkSaving">

    <detailHeader />
    <Header />
    <!-- 装箱状态和列表操作合并为同一行，原功能及显示条件保持不变。 -->
    <div class="detailToolbar">
      <PackingTabs v-if="status == 21" />
      <!-- 列配置/自定义表头 -->
      <div class="column-settings-bar">
        <el-button v-if="isAuth(779)" type="success" size="small" @click="openAssignSealer">
          {{ $t('message.adjustPorderSealer') }}
        </el-button>
        <el-button type="primary" size="small" @click="columnSettingsVisible = true">
          {{ $t('message.customColumns') }}
        </el-button>
        <el-button v-if="materialRows.length" size="small" @click="toggleAllMaterials">
          {{ allMaterialsExpanded ? $t('message.materialCollapseAll') : $t('message.materialExpandAll') }}
        </el-button>
      </div>
    </div>
    <!-- 详情 -->
    <div class="orderDetail">
      <!--列表  -->
      <div class="table">
        <ol>
          <!-- NO / 选择 -->
          <li class="no-column">NO / {{ $t("message.choose") }}</li>
          <!-- 订单号 -->
          <li v-if="isColumnVisible('orderSn')" class="orderNumberColumn">{{ $t("message.orderNumber") }}</li>
          <!-- 番号 -->
          <li v-if="isColumnVisible('sorting')" class="flex05 sortingColumn">{{ $t("message.mash") }}</li>
          <!-- 照片 -->
          <li v-if="isColumnVisible('picture')" class="pictureColumn">{{ $t("message.pic") }}</li>
          <!-- 业务编辑商品属性 -->
          <li v-if="isColumnVisible('commodityProperties')" class="commodityPropertiesColumn">
            {{ $t("message.theBusinessEditsTheCommodityProperties") }}
          </li>
          <!-- 数量 -->
          <li v-if="isColumnVisible('quantity')" class="quantityColumn">{{ $t("message.quantity") }}</li>
          <!--仓库数量  -->
          <li class="flex" v-if="status == 21 && isColumnVisible('warehouseNumber')">
            {{ $t("message.warehouseNumber") }}
          </li>
          <!-- 装箱情况 -->
          <li v-if="status >= 21 && isColumnVisible('packingCase')" class="compactColumn">
            {{ $t("message.packingCase") }}
          </li>
          <!-- 商品费用 -->
          <li v-if="status == 20 && isColumnVisible('goodsCost')">{{ $t("message.forGoods") }}</li>
          <!-- 附加服务 -->
          <li v-if="isColumnVisible('additionalServices')" class="flex15">{{ $t("message.additionalServices") }}</li>
          <!-- 标签编号 -->
          <li v-if="isColumnVisible('tagNumber')" class="tagNumberColumn">{{ $t("message.tagNumber") }}</li>
          <!-- 标签匹配数量 -->
          <!-- <li>{{ $t("message.numberOfTagMatches") }}</li> -->
          <!-- 标签导入数量 -->
          <li v-if="isColumnVisible('labelImportQuantity')" class="labelImportQuantityColumn">
            {{ $t("message.labelImportQuantity") }}
          </li>
          <!--纳品数量 -->
          <li class="flex2" v-if="isAmazonOrStockcrew && isColumnVisible('amazonDelivery')">{{ $t("message.amazonDelivery") }}
            <el-popover placement="top" width="500" trigger="hover" title="注意：">
              <p>1.如果实际进仓数量与生成的纳品计划内商品数量不一致可能会影响客户店铺</p>
              <p>2.【预计纳品数】、【实际纳品数】与系统上的【出货数】属于不同概念，如配套商品：出货数100个，要求2个1套则纳品数为50。</p>
              <p>3.配套用的附属商品、感谢卡、说明书等无商品标信息的无须填写【预计纳品数】与【实际纳品数】。如误填了商品标信息，则会生成错误的纳品计划。</p>
              <p>4.配送单内如有多番商品标重复的情况，注意检查纳品总数是否正确。</p>
              <i class="el-icon-question" slot="reference"></i>
            </el-popover>
          </li>
          <!-- 客户配送单商品备注 -->
          <li v-if="isColumnVisible('customerDeliveryNote')" class="customerDeliveryNoteHeader remarkColumn">
            {{ $t("message.customerDeliveryNote") }}
          </li>
          <!-- 业务回复 -->
          <li v-if="isColumnVisible('businessReply')" class="remarkColumn">{{ $t("message.businessReply") }}</li>
          <!-- 业务商品备注 -->
          <li v-if="isColumnVisible('businessCommodityRemarks')" class="remarkColumn">
            {{ $t("message.businessCommodityRemarks") }}
          </li>
          <!-- 交易/物流号 -->
          <li class="flex15" v-if="status >= 21 && isColumnVisible('transactionLogisticsNumber')">
            {{ $t("message.transactionLogisticsNumber") }}
          </li>
          <!-- 操作员 -->
          <li v-if="isColumnVisible('operator')">{{ $t("message.operator") }}</li>
          <!-- 检品详细 -->
          <li v-if="isColumnVisible('inspectionDetail')" class="compactColumn">
            {{ $t('message.inspectionDetail') }}
          </li>
        </ol>
        <div v-for="(item, index) in list" :key="index" class="porderGoodsGroup"
          v-show="item.wait_freight_num != 0 || status != 21 || isPack != 1">
        <ul :class="{ tagSame: !item.tagSame && status == 20 }">
          <!-- NO / 选择：合并展示，原有选择、标识和展开功能保持不变。 -->
          <li class="selectCell no-column">
            <div class="noTopRow">
              <div class="noSelection">
                <el-popover placement="right" title="合计数量" width="200" trigger="focus">
                  <statistics :checkedList="selectedList" />
                  <el-checkbox v-model="item.checked" @change="Single" slot="reference"></el-checkbox>
                </el-popover>
              </div>
              <b>{{ item.NO }}</b>
            </div>
            <div class="noStatusArea">
              <div class="noBadgeRow">
                <!-- 抽查详细 -->
                <spotCheckDetails v-if="item.spotDetail != false" :spotDetail="item.spotDetail" />
                <!-- 售中问题 -->
                <div class="inSale" v-if="item.inSale != false">
                  <el-popover placement="top-end" width="350" trigger="hover">
                    <div v-for="(problem_goods) in item.inSale">
                      <p>问题提出时间：{{ problem_goods.created_at }}</p>
                      <p>问题类别：{{ problem_goods.type_name }}</p>
                      <p>具体问题描述：{{ problem_goods.description }}</p>
                    </div>
                    <router-link :to="`/inSaleList?order_sn=${item.order_sn}&status=${item.inSale[0].status}`"
                      slot="reference" class="wen" target="_blank">
                      问
                    </router-link>
                  </el-popover>
                </div>
              </div>
            </div>
            <!-- 展开按钮始终可见 -->
            <el-button class="materialToggle" type="text" size="mini"
              @click.stop="toggleMaterial(item)">
              {{ item.materialExpanded ? $t("message.collapse") : $t("message.expand") }}
              <i :class="item.materialExpanded ? 'el-icon-arrow-up' : 'el-icon-arrow-down'"></i>
            </el-button>
          </li>
          <!-- 订单号 -->
          <li v-if="isColumnVisible('orderSn')" class="orderNumberColumn">
            <router-link class="orderNumberLink" :to="'/orderPaymentDetail?order_sn=' + item.order_sn" target="_blank">
              {{ item.order_sn }}</router-link>
            <div v-if="item.isZhu" class="kitAssemblyBadge kitAssemblyMain"
              @click="$refs.kitAssembly.getDataList(item.group)">
              组套-主
            </div>
            <div v-if="item.set_detail_id != '' && item.set_detail_id != -1"
              class="kitAssemblyBadge kitAssemblyBundle" @click="$refs.kitAssembly.getDataList(item.group)">
              组套-{{ getSorting(item.set_detail_id) }}番-同捆
            </div>
          </li>
          <!-- 番号 -->
          <li v-if="isColumnVisible('sorting')" class="flex05 sortingColumn">
            <!-- 当前商品为辅料时显示辅料标识 -->
            <div v-if="item.is_material == 1" class="materialMarkTip" @click.stop>
              <MaterialMarkTip :material-id="item.material_id" :user-id="detail.user_id" :detail="item.material" />
            </div>
            <div class="sorting">
              {{ item.sorting }}
              <!-- 是否加入商品管理 -->
              <div class="claim" v-if="item.client_product_mark">
                <!-- 配送单统一跳转新版商品管理，已有管理番号时带上筛选条件。 -->
                <router-link
                  :to="{ name: 'productManagementV2', query: { tab: 'all', user_id: detail.user_id, client_sku_code: item.client_sku_code } }"
                  target="_blank">
                  <i :class="item.client_product_mark == 1 ? 'el-icon-shopping-bag-1' : 'el-icon-s-claim'"></i>
                </router-link>
              </div>
              <!-- 严禁品 -->
              <div class="contraband" v-if="item.forbid_goods != false">
                <el-popover placement="right" width="200" trigger="hover">
                  <div> {{ item.forbid_goods.type_name }}</div>
                  <img src="@/assets/img/contraband1.png" alt="" slot="reference" v-if="item.forbid_goods.status == 3">
                  <img src="@/assets/img/contraband.png" alt="" slot="reference" v-else>
                </el-popover>
              </div>
            </div>
          </li>
          <!-- 照片 -->
          <li v-if="isColumnVisible('picture')" class="pictureColumn">
            <div>
              <el-popover placement="right" width="300" trigger="hover">
                <img :src="item.pic" alt="" style="width: 300px; height: 300px" />
                <a :href="item.link" slot="reference" target="_blank">
                  <el-image :src="item.pic" style="width: 60px; height: 60px; border-radius: 4px">
                    <div slot="placeholder" class="image-slot">
                      加载中<span class="dot">...</span>
                    </div>
                  </el-image>
                </a>
              </el-popover>
              <p>{{ item.for_sn }}</p>
            </div>

          </li>
          <!-- 业务编辑商品属性 -->
          <li v-if="isColumnVisible('commodityProperties')" class="commodityPropertiesColumn">
            <div class="attribute">
              <el-tooltip placement="bottom">
                <div slot="content">
                  <div class="row"
                    v-for="(itemDetail, itemIndex) in item.detail_y != false ? item.detail_y : item.detail"
                    :key="itemIndex" style="margin-bottom: 5px">
                    {{ itemDetail.key }}：{{ itemDetail.value }}
                  </div>
                </div>
                <div>
                  <div class="row"
                    v-for="(itemDetail, itemIndex) in item.detail_y != false ? item.detail_y : item.detail"
                    :key="itemIndex">
                    {{ itemDetail.key }}：{{ itemDetail.value }}
                  </div>
                </div>
              </el-tooltip>
            </div>
          </li>
          <!-- 数量 -->
          <li v-if="isColumnVisible('quantity')" class="quantityColumn">
            <div :class="{ tips: item.num != item.freight_num && status == 22 }" class="template">
              <!-- 提出数 -->
              <p class="putForwardNum" :class="{ stockTotal: item.num < item.stockTotal }">
                <span  v-if="status == 20 && isAuth(236)">
                  {{ $t("message.putForwardNum") }}：
                <el-input v-model="item.num" size="mini"
                  onkeyup.native="value=value.replace(/^(0+)|[^\d]+/g,'')" type="number"
                  style="display: inline-block; width: 56px">
                </el-input>
                </span>
               
                <span v-else>
                  {{ $t("message.putForwardNum") }}：{{ item.num }}
                </span>
              </p>
              <!-- 待装箱 -->
              <p>
                {{ $t("message.toEncasement") }}：{{ item.wait_freight_num }}
              </p>
              <!-- 已装箱 -->
              <p>{{ $t("message.boxed") }}：{{ item.freight_num }}</p>
              <!-- 已出货 -->
              <p>{{ $t("message.shipped") }}：{{ item.delivery_num }}</p>
              <!-- 上架可能数 -->
              <p>{{ $t("message.possibleNumberOfShelves") }}：{{ item.possible_num }}</p>
            </div>
          </li>
          <!-- 仓库数量 -->
          <li class="flex" v-if="status == 21 && isColumnVisible('warehouseNumber')">
            <div class="template">
              <div class="row" v-for="(items, indexs) in item.wms_stock" :key="indexs">
                <p>{{items.wms_grid.floor}}-{{ items.wms_grid_name }}</p>
                <p>{{ $t("message.quantity") }}: <span :class="{ abnormal: items.num != item.wait_freight_num }">
                    {{ items.num }}</span> </p>
              </div>
            </div>
          </li>
          <!-- 装箱情况 -->
          <li v-if="status >= 21 && isColumnVisible('packingCase')" class="compactColumn">
            <!-- 查看 -->
            <el-popover placement="right" width="400" trigger="click">
              <el-table :data="freightDetailData" border :header-cell-style="{ background: '#EDEFF4' }"
                style="width: 100%">
                <el-table-column property="porder_freight.porder_sn" label="配送单号" align="center"></el-table-column>
                <el-table-column property="porder_freight.number" label="配送单箱号" align="center"
                  width="100"></el-table-column>
                <el-table-column property="num" label="装箱数量" align="center" width="100"></el-table-column>
              </el-table>

              <el-button type="text" @click="sortingBoxDetail(item.id)" slot="reference">
                {{ $t("message.check") }}
              </el-button>
            </el-popover>
          </li>
          <!-- 商品费用 -->
          <li v-if="status == 20 && isColumnVisible('goodsCost')">
            <div>
              <!-- 价格 -->
              <p>{{ $t("message.price") }}：{{ item.confirm_price }}</p>
              <!-- 运费 -->
              <p>{{ $t("message.freight") }}：{{ item.freight }}</p>
              <!--小计 -->
              <p>
                {{ $t("message.subtotal") }}：
                {{ (item.confirm_price * item.num + item.freight).toFixed(2) }}
              </p>
            </div>
          </li>
          <!-- 附加服务 -->
          <li v-if="isColumnVisible('additionalServices')" class="flex15">
            <div class="template">
              <!-- 服务单标记独立放在附加服务列表上方，避免与option内容混排。 -->
              <div v-if="item.option_service_list != false" style="margin-bottom: 4px">
                <el-tag size="mini" type="primary">已提出服务单</el-tag>
              </div>
              <el-tooltip placement="bottom" style="max-height: 100px">
                <div slot="content">
                  <div class="row" v-for="(opti, optiIndex) in item.option" :key="optiIndex" style="margin-bottom: 3px">
                    <p>
                      {{ optiIndex + 1 }}.{{ opti.name }}:
                      <span v-if="opti.price_type != 1">{{ opti.num }} * {{ opti.price }}元</span>
                      <span v-else> {{ opti.price }}% </span>
                    </p>
                  </div>
                </div>
                <div>
                  <div class="row" v-for="(opti, optiIndex) in item.option" :key="optiIndex">
                    <p>
                      {{ optiIndex + 1 }}.{{ opti.name }}:
                      <span v-if="opti.price_type != 1">{{ opti.num }}*{{ opti.price }}元</span>
                      <span v-else> {{ opti.price }}% </span>
                    </p>
                  </div>
                </div>
              </el-tooltip>
            </div>
          </li>
          <!-- 标签编号 -->
          <li v-if="isColumnVisible('tagNumber')" class="tagNumberColumn">
            <div class="template tagContent">
              <div v-for="(tag, tagIndex) in item.porder_detail_tag" :key="tagIndex" class="tags">
                <!-- 标签操作区：仅调整布局，保留原权限与状态判断。 -->
                <div class="tagActions">
                  <el-button size="mini" type="primary" @click="labelCheck(item.order_detail_id, tag.id)"
                    v-if="item.porder_detail_tag != false && status == 21">
                    {{ $t("message.labelCheck") }}
                  </el-button>
                  <el-button size="mini" type="primary" class="primary" @click="tagEditing(tag)"
                    v-if="status == 20 && isAuth(232)">
                    {{ $t("message.compile") }}
                  </el-button>
                  <el-button size="mini" type="primary" class="dark" @click="deleteFbaSign(tag)" v-if="status == 20">
                    {{ $t("message.delete") }}
                  </el-button>
                  <el-button size="mini" type="primary" @click="lookTag(tag.porder_detail_tag_print)"
                    v-if="tag.porder_detail_tag_print != false">
                    <i class="el-icon-time"></i>
                  </el-button>
                  <el-button size="mini" type="primary" class="primary tagPrint"
                    @click="fbaPrint(tag, '', tag.is_print)">
                    {{ !tag.is_print ? $t("message.print") : $t("message.printed") }}
                  </el-button>
                </div>
                <!-- 标签字段按付完款订单详情的双列表格样式展示。 -->
                <div class="tagRecord">
                  <div class="tagField"><span class="tagLabel">类别</span><span class="tagValue">{{ tag.type }}</span></div>
                  <div class="tagField">
                    <span class="tagLabel">{{ $t("message.labelNo") }}</span>
                    <span class="tagValue">{{ tag.no }}<img src="@/assets/icon/条形码.svg" alt="" class="barcodeIcon"></span>
                  </div>
                  <div class="tagField"><span class="tagLabel">{{ $t("message.commodityCode") }}</span><span class="tagValue">{{ tag.goods_no }}</span></div>
                  <div class="tagField"><span class="tagLabel">{{ $t("message.codingRule") }}</span><span class="tagValue">{{ tag.code_type }}</span></div>
                  <div class="tagField"><span class="tagLabel">文本描述</span><span class="tagValue">{{ tag.text_line_one }}</span></div>
                  <div class="tagField"><span class="tagLabel">文本描述2</span><span class="tagValue">{{ tag.text_line_two }}</span></div>
                  <div class="tagField"><span class="tagLabel">文本描述3</span><span class="tagValue">{{ tag.text_line_three }}</span></div>
                  <div class="tagField"><span class="tagLabel">文本描述4</span><span class="tagValue">{{ tag.text_line_four }}</span></div>
                  <div class="tagField">
                    <span class="tagLabel">{{ $t("message.numberOfLabels") }}</span>
                    <span class="tagValue tagCountValue">
                      <span>{{ tag.num }}</span>
                      <el-button size="mini" type="primary" class="primary"
                        @click="fbaPrint(tag, 'hide', tag.is_print)" v-if="status < 60">
                        {{ $t("message.plainTextLabel") }}
                      </el-button>
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </li>
          <!-- 标签匹配数量 -->
          <li v-if="isColumnVisible('labelImportQuantity')" class="labelImportQuantityColumn">
            <div class="template">

              <p style="margin-bottom: 10px;">
                <!-- 新建标签 -->
                <el-button size="mini" type="primary" class="secondary" @click="labelNumberAdd(item)"
                  v-if="isAuth(232) && status == 20">
                  {{ $t("message.labelNumberAdd") }}
                </el-button>
              </p>

              <!-- 历史标签 -->
              <el-button type="primary" size="mini" style="margin-bottom: 50px;" @click="historyTag(item)">
                {{ $t('message.historyTag') }}</el-button>
              <div class="tagMatchCount" v-for="(tag, tagIndex) in item.porder_detail_tag" :key="tagIndex"
                :class="{ bacRed: tag.match_num != tag.num }">
                标签{{ tagIndex + 1 }}: {{ tag.match_num }}
              </div>
            </div>
          </li>
          <!-- 纳品数量 -->
          <li class="flex2" v-if="isAmazonOrStockcrew && isColumnVisible('amazonDelivery')">
            <div class="template" style="line-height: 30px; " v-if="item.porder_detail_tag != false">
              <p>预计纳品数<el-popover placement="top" width="400" trigger="hover">
                  <p>
                    客户提交配送单时会按出货数自动填写【预计纳品数】。配套商品会根据客户在补货链接处维护的数量自动计算配套数量，如客户未维护补货链接，则需要客户手动修改【预计纳品数】。提出配送单后，系统会根据【预计纳品数】在自动生成纳品计划。
                  </p>
                  <i class="el-icon-question" slot="reference"></i>
                </el-popover>:{{ item.planned_num }}
              </p>
              <div style="display: flex;" v-if="status >= 22">
                实际纳品数<el-popover placement="top" width="400" trigger="hover">
                  <p> 默认与【预计纳品数】一致。装箱过程中出现缺货、不良等情况导致纳品数减少的，需要业务员按照实际数量修改【实际纳品数】后报价，并及时联系客户说明情况。</p>
                  <i class="el-icon-question" slot="reference"></i>
                </el-popover>:
                <el-input v-model="item.received_num" size="mini" style="width: 70px;" v-if="status == 22"
                  @input="handleInput($event, index, item)" @blur="updateDeliveryNumber(item)"></el-input>
                <span v-else>{{ item.received_num }}</span>
              </div>
            </div>
          </li>
          <!-- 客户商品备注 -->
          <li v-if="isColumnVisible('customerDeliveryNote')" class="customerDeliveryNoteCell remarkColumn">
            {{ item.client_remark }}
          </li>
          <!-- 业务回复 -->
          <li v-if="isColumnVisible('businessReply')" class="remarkColumn">{{ item.y_reply }}</li>
          <!-- 业务商品备注 -->
          <li v-if="isColumnVisible('businessCommodityRemarks')" class="remarkColumn">
            <el-input type="textarea" placeholder="请输入内容" v-model="item.y_remark" v-if="status == 20"
              @input="allEdit(item.y_remark, 'y_remark', item.checked)" @blur="updateDetailRemark(item)">
            </el-input>
            <span v-else>{{ item.y_remark }} </span>
          </li>
          <!-- 交易/物流号 -->
          <li class="flex15" v-if="status >= 21 && isColumnVisible('transactionLogisticsNumber')">
            <div class="template">
              <div class="row" v-for="(items, indexs) in item.order_purchase" :key="indexs">
                <p>
                  JY:<a href="javascript:;" rel="noopener noreferrer" style="color: #fa5058">{{ items.purchase_no }}</a>
                </p>
                <!--物流 入库码  -->
                <div v-for="(express_no, express_noIndex) in items.order_purchase_express" :key="express_noIndex">
                  <p v-if="express_no.entry_code" class="entry-code">{{ express_no.entry_code }}</p>
                  <p>
                    WL:<a href="javascript:;" rel="noopener noreferrer" style="color: #2c96e7">{{ express_no.express_no
                    }}</a>
                  </p>
                </div>
              </div>
              <!-- 库位出货数 -->
              <div class="row" v-for="(grids, gridsIndex) in item.from_grids" :key="gridsIndex+10086">
                <p> {{fromGrids(grids) }}</p>
                 
              </div>
            </div>
          </li>
          <!-- 操作员 -->
          <li v-if="isColumnVisible('operator')">
            <div class="template">
              <div class="name">
                <span>{{ $t("message.business") }}:{{ item.y_name }}</span>
              </div>
              <div class="name">
                <span>{{ $t("message.purchase") }}:{{ item.g_name }}</span>
              </div>
              <div class="name">
                <span>{{ $t("message.distribution") }}:{{ item.p_name }}</span>
              </div>
            </div>
          </li>
          <!-- 检品详细 -->
          <li v-if="isColumnVisible('inspectionDetail')" class="compactColumn">
            <!-- 检品详细 -->
            <span @click="purchaseInspectDetail(item)" class="a-link">
              {{ $t('message.detail') }}
            </span>
          </li>
        </ul>
        <!-- 无辅料时也显示展开区；右侧按工种展示要求，业务可直接编辑三项。 -->
        <div v-show="item.materialExpanded" class="materialRequirements">
          <div class="materialRequirementsList">
            <MaterialInfo :list="getMaterialInfoList(item)" :order-quantity="item.num" :user-id="detail.user_id"
              :editable="false" :removable="false" />
          </div>
          <div class="materialRequirementsRemarks"
            :class="{ singleRequirement: visibleRequirements.length === 1, doubleRequirement: visibleRequirements.length === 2 }">
            <div v-if="visibleRequirements.includes('purchase')" class="requirementItem">
              <label>{{ $t('message.productV2PurchaseRequirement') }}</label>
              <el-input v-model="item.purchase_remark" type="textarea" :rows="4" resize="none"
                :readonly="!isBusiness" @blur="savePlanRemark(item, 'purchase_remark')" />
            </div>
            <div v-if="visibleRequirements.includes('inspect')" class="requirementItem">
              <label>{{ $t('message.productV2InspectionRequirement') }}</label>
              <el-input v-model="item.inspect_remark" type="textarea" :rows="4" resize="none"
                :readonly="!isBusiness" @blur="savePlanRemark(item, 'inspect_remark')" />
            </div>
            <div v-if="visibleRequirements.includes('delivery')" class="requirementItem">
              <label>{{ $t('message.productV2AllocationRequirement') }}</label>
              <el-input v-model="item.delivery_remark" type="textarea" :rows="4" resize="none"
                :readonly="!isBusiness" @blur="savePlanRemark(item, 'delivery_remark')" />
            </div>
          </div>
        </div>
        </div>
        <!-- 配送单数量及费用汇总靠左突出展示。 -->
        <ul id="total" class="deliveryTotals" v-if="status > 20">
          <!--发送数-->
          <li>{{ $t("message.numberOfTransmissions") }}:{{ num }}</li>
          <!-- 小计 -->
          <li>{{ $t("message.subtotal") }}:{{ subtotal }}</li>
          <!-- 国内运费 -->
          <li>
            {{ $t("message.domesticFreight") }}:{{ detail.total_freight_china.toFixed(2) }}
          </li>
        </ul>
      </div>
      <!-- 翻译操作 -->
      <div class="operate">
        <translateOperation :selectedList="selectedList" @allChecked="allChecked" v-if="status == 20" />
      </div>
    </div>
    <columnSettingsDialog :visible.sync="columnSettingsVisible" :columns="availableColumnOptions"
      :value="visibleColumns" @save="saveColumnSettings" />
    <!-- 箱子 -->
    <div class="box">
      <boxList v-if="status > 20" />
      <!-- 新增箱子 -->
      <addBox ref="addBox" :porder_sn="porder_sn" />
      <!-- 修改箱规 -->
      <boxGaugeModification ref="boxGaugeModification" />
      <!-- 修改箱子重量 -->
      <modificationOfWeigh ref="modificationOfWeigh" />
      <!-- 取消装箱 -->
      <cancelEncasement ref="cancelEncasement" />
      <!-- 箱子详情 加移箱 -->
      <movingGoodsBox ref="movingGoodsBox" />
      <!-- 标签核对 -->
      <fbaScanList ref="fbaScanList" :fbaScanData="fbaScanData" />
    </div>
    <!-- 装箱操作 -->
    <div class="operate" v-if="status == 21">
      <packingOperation :selectedList="selectedList" @allChecked="allChecked" />
    </div>
    <!--  报价操作-->
    <div class="operate" v-if="status == 22 && boxList != false">
      <offerOperation @allChecked="allChecked" :selectedList="selectedList" />
    </div>
    <!-- 待支付操作 -->
    <div class="operate" v-if="status == 30">
      <toBePaidOperation @allChecked="allChecked" :selectedList="selectedList" />
    </div>
    <!-- 待出货操作 -->
    <div class="operate" v-if="status == 50">
      <toBeShippedOperation @allChecked="allChecked" :selectedList="selectedList" />
    </div>
    <!-- 待出货操作 -->
    <div class="operate" v-if="status >= 60">
      <internationalDeliveryOperation @allChecked="allChecked" :selectedList="selectedList" />
    </div>

    <!-- 底部地址 -->
    <footerPage />
    <!-- 配送单拆分 -->
    <distributionOrderSplitting v-if="distributionOrderSplittingDialogVisible" :selectedList="selectedList" />
    <!-- 装箱 -->
    <encasement :selectedList="selectedList" ref="encasement" />
    <!-- 报价配送单拆分 -->
    <offerDistributionOrderSplitting ref="offerDistributionOrderSplitting" />
    <!-- 国际物流 -->
    <InternationalFreight ref="InternationalFreight" :selectedList="selectedList" />
    <!-- 其他费用 -->
    <otherExpenses ref="otherExpenses" />
    <!--标签编号编辑  -->
    <tagEditing ref="tagEditing" :tagData="tagData" />
    <!-- 标签匹配 -->
    <tagMatching ref="tagMatching" :selectedList="selectedList" />
    <!-- 特殊客户标签匹配 -->
    <specialCustomerLabels ref="specialCustomerLabels" :selectedList="selectedList" />
    <!--  批量填写物流单号 -->
    <wuliuFillIn ref="wuliuFillIn" />
    <!-- 整个单子售后 -->
    <wholeOrderAfterSale ref="wholeOrderAfterSale" />
    <!-- 具体商品售后 -->
    <afterSaleOfGoods ref="afterSaleOfGoods" />
    <!--  配送单回退重新报价记录 -->
    <requotationOfDeliveryOrder ref="requotationOfDeliveryOrder" />
    <!-- 修改标签数量 -->
    <tagEditNum ref="tagEditNum" :tagData="tagData" />
    <!-- EMS打印 -->
    <div v-show="false">
      <div ref="EMSprintingmark" v-if="logistics == 'EMS' || logistics == 'EMS船便'">
        <EMSprintingmark />
      </div>
    </div>
    <!-- OCS打印 -->
    <div v-show="false">
      <!-- 授权 -->
      <div ref="OCSCustomerShippingmark" v-if="logistics == 'OCS' && is_authorized">
        <OCSCustomerShippingmark />
      </div>
      <!-- 没授权的 -->
      <div ref="OCSCustomerShippingmark" v-if="logistics == 'OCS' && !is_authorized">
        <OCSShippingmark />
      </div>
    </div>
    <!-- TW打印 -->
    <div v-show="false">
      <!-- 授权 -->
      <div ref="TWCustomerShippingmark" v-if="logistics == 'TW船便' &&
        is_authorized">
        <TWCustomerShippingmark />
      </div>
      <!-- 没授权的 -->
      <div ref="TWCustomerShippingmark" v-if="logistics == 'TW船便' &&
        !is_authorized">
        <TWCustomerShippingmarkNormal />
      </div>
    </div>
    {{ is_authorized }}
    <!-- DQ打印 -->
    <div v-show="false">

      <!-- 授权 -->
      <div ref="DQShippingmark" v-if="(allowedLogistics.includes(logistics) && is_authorized)">
        <DQCustomerShippingmark />
      </div>
      <!-- 没授权的 -->
      <div ref="DQShippingmark" v-if="(allowedLogistics.includes(logistics) && !is_authorized)">
        <DQShippingmark />
      </div>
    </div>
    <!-- KS-JP航空便 KS-JP航空経済便-->

    <div v-show="false">
      <div ref="KS_JPShippingmark"
        v-if="logistics == 'KS-JP航空便' || logistics == 'KS-JP航空経済便' || logistics == 'KS-JP電子特殊便'">
        <!-- v-for="(item, index) in printData" :key="index" :datas="item"  -->
        <KS_JPShippingmark />
      </div>
    </div>
    <!-- 标签打印 -->
    <div v-show="false">
      <div v-if="printTagData != null" ref="tabPrint">
        <tabPrint :printTagData="printTagData" :isExpress="isExpress" v-for="item in tabPrintNum" :key="item" />
      </div>
    </div>
    <!-- RW船便 -->
    <div v-show="false" v-if="logistics == 'RW船便'">
      <div ref="RWCustomerShippingmark">
        <RWCustomerShippingmark />
      </div>
    </div>
    <!-- Raku_DQ -->
    <div v-show="false" v-if="logistics == 'Raku-DQ'">
      <div ref="Raku_DQShippingmark">
        <Raku_DQShippingmark />
      </div>
    </div>
    <!-- 废品打印 -->
    <div v-show="false" v-if="logistics == '废弃'">
      <div ref="abandoned">
        <abandoned />
      </div>
    </div>
    <!-- 历史标签 -->
    <goodsTagLog ref="goodsTagLog" :itemData="itemData" />
    <!-- 注意事项 -->
    <getNotice ref="getNotice" />
    <!-- 检品注意事项 -->
    <getNotice ref="JPgetNotice" />
    <!-- 检品状态详情 -->
    <inspectDetail ref="inspectDetail" :tableData="inspectDetailList" />
    <!-- 签上传匹配 -->
    <fbaMatchNotice ref="fbaMatchNotice" />
    <!-- 标签批量修改条码格式  -->
    <batchModifyCodeType ref="batchModifyCodeType" />
    <!-- 二次标签打印 -->
    <printAgain ref="printAgain" :order_detail_tag_id="order_detail_tag_id" />
    <!--查看历史打印  -->
    <lookTag ref="lookTag" :porder_detail_tag_print="porder_detail_tag_print" />
    <!--申请过标签 提示  -->
    <appliedLabels ref="appliedLabels" />
    <!-- 新增服务单 -->
    <addServiceOrder ref="addServiceOrder" :selectedList="selectedList" :porder_sn="porder_sn" />
    <!-- 创建服务单 -->
    <createServiceOrder ref="createServiceOrder" />
    <!-- 追加仓库商品 -->
    <addGoods ref="addGoods" />
    <!-- 与列表共用调整封箱员弹窗，详情只传当前配送单。 -->
    <assignSealerDialog ref="assignSealerDialog" :candidates="sealerCandidates" :loading="sealerCandidatesLoading"
      :can-assign="isAuth(779)" @saved="refreshSealerDetail" />
    <!-- 单商品取消装箱 -->
    <singleProductCancellation ref="singleProductCancellation" :selectedList="selectedList" :porder_sn="porder_sn" />
    <!--  多箱一键取消  -->
    <oneCancellatioBoxes ref="oneCancellatioBoxes" />
    <!-- 同捆商品 -->
    <kitAssembly ref="kitAssembly" :order_detail="list" />
    <!-- 售中问题产品 -->
    <inSalePreview ref="inSalePreview" :porder_sn="porder_sn" />
    <!-- 该配送单为FBA配送单 提示 -->
    <is_FBA ref="is_FBA" />
    <unprintedTagPrompt :detail="detail" :list="list" />
    <!-- 预设任务 -->
    <presetTask ref="presetTask" />

  </div>
</template>
<script>
import detailHeader from "@/components/header/detailHeader";
import Header from "./components/header.vue";
import footerPage from "./components/footer";
import translateOperation from "./components/translate/operation";
import goodsTagLog from "./components/translate/goodsTagLog";
import distributionOrderSplitting from "./components/translate/distributionOrderSplitting";
import packingOperation from "./components/packing/operation";
import boxList from "./components/packing/boxList";
import addBox from "./components/packing/addBox";
import PackingTabs from "./components/packing/PackingTabs";
import fbaMatchNotice from "./components/packing/fbaMatchNotice";
import boxGaugeModification from "./components/packing/boxGaugeModification";
import modificationOfWeigh from "./components/packing/modificationOfWeigh";
import encasement from "./components/packing/encasement";
import cancelEncasement from "./components/packing/cancelEncasement";
import movingGoodsBox from "./components/packing/movingGoodsBox";
import singleProductCancellation from "./components/packing/singleProductCancellation";
import oneCancellatioBoxes from './components/packing/oneCancellatioBoxes'
import offerOperation from "./components/offer/operation";
import offerDistributionOrderSplitting from "./components/offer/distributionOrderSplitting";
import InternationalFreight from "./components/offer/InternationalFreight";
import otherExpenses from "./components/offer/otherExpenses";
import toBePaidOperation from "./components/toBePaid/operation";
import tagEditing from "./components/translate/tagEditing";
import tagMatching from "./components/translate/tagMatching";
import specialCustomerLabels from './components/translate/specialCustomerLabels'
import toBeShippedOperation from "./components/toBeShipped/operation";
import wuliuFillIn from "./components/toBeShipped/wuliuFillIn";
import internationalDeliveryOperation from "./components/InternationalDelivery/operation";
import wholeOrderAfterSale from "./components/InternationalDelivery/wholeOrderAfterSale";
import afterSaleOfGoods from "./components/InternationalDelivery/afterSaleOfGoods";
import EMSprintingmark from "@/components/Printedsheet/EMSprintingmark";
import TWCustomerShippingmark from "@/components/Printedsheet/TWCustomerShippingmark";
import TWCustomerShippingmarkNormal from "@/components/Printedsheet/TWCustomerShippingmarkNormal";
import OCSCustomerShippingmark from "@/components/Printedsheet/OCSCustomerShippingmark";
import OCSShippingmark from "@/components/Printedsheet/OCSShippingmark";
import DQShippingmark from "@/components/Printedsheet/DQShippingmark";
import DQCustomerShippingmark from "@/components/Printedsheet/DQCustomerShippingmark";
import requotationOfDeliveryOrder from "./components/InternationalDelivery/requotationOfDeliveryOrder";
import tabPrint from "@/components/Printedsheet/tag/tabPrint.vue";
import KS_JPShippingmark from "@/components/Printedsheet/KS_JPShippingmark.vue";
import RWCustomerShippingmark from "@/components/Printedsheet/RWCustomerShippingmark.vue";
import tagEditNum from "./components/tagEditNum.vue";
import statistics from './components/statistics'
import fbaScanList from './components/packing/fbaScanList'
import inspectDetail from '@/components/box/inspectDetail'
import abandoned from "@/components/Printedsheet/abandoned.vue";
import Raku_DQShippingmark from "@/components/Printedsheet/Raku-DQShippingmark";
import batchModifyCodeType from './components/translate/batchModifyCodeType'
import printAgain from './components/packing/printAgain'
import lookTag from './components/packing/lookTag'
import appliedLabels from './components/offer/appliedLabels'
import addServiceOrder from './components/packing/addServiceOrder'
import createServiceOrder from '@/components/common/createServiceOrder'
import addGoods from '@/views/home/userOrderManagement/order/deliveryPreview/components/addGoods'
import kitAssembly from '@/views/orderDetail/components/kitAssembly'
import inSalePreview from '@/components/inSale/inSalePreview'
import is_FBA from './components/packing/is_FBA'
import unprintedTagPrompt from './components/offer/unprintedTagPrompt'
import spotCheckDetails from '@/components/common/spotCheckDetails'
import presetTask from '@/components/presetTask/index'
import columnSettingsDialog from './components/columnSettingsDialog'
import assignSealerDialog from '@/views/home/porder/porderLabeling/components/assignSealerDialog'
import MaterialInfo from '@/components/common/materialInfo'
import MaterialMarkTip from '@/components/common/materialMarkTip'
import { mapState } from "vuex";
import { getPlanRemarkSnapshot, normalizePlanRemark, shouldExpandPlanRemark } from '@/utlis/materialRemark'
import { getAreaGridName } from '@/utlis/warehouseGrid'

// 选择和 NO 固定显示，其余列均可配置；状态条件只决定弹框当前提供哪些选项。
const columnOptions = [
  { key: 'orderSn', labelKey: 'message.orderNumber' },
  { key: 'sorting', labelKey: 'message.mash' },
  { key: 'picture', labelKey: 'message.pic' },
  { key: 'commodityProperties', labelKey: 'message.theBusinessEditsTheCommodityProperties' },
  { key: 'quantity', labelKey: 'message.quantity' },
  { key: 'warehouseNumber', labelKey: 'message.warehouseNumber', statuses: [21] },
  { key: 'packingCase', labelKey: 'message.packingCase', minStatus: 21 },
  { key: 'goodsCost', labelKey: 'message.forGoods', statuses: [20] },
  { key: 'additionalServices', labelKey: 'message.additionalServices' },
  { key: 'tagNumber', labelKey: 'message.tagNumber' },
  { key: 'labelImportQuantity', labelKey: 'message.labelImportQuantity' },
  { key: 'amazonDelivery', labelKey: 'message.amazonDelivery', amazonOnly: true },
  { key: 'customerDeliveryNote', labelKey: 'message.customerDeliveryNote' },
  { key: 'businessReply', labelKey: 'message.businessReply' },
  { key: 'businessCommodityRemarks', labelKey: 'message.businessCommodityRemarks' },
  { key: 'transactionLogisticsNumber', labelKey: 'message.transactionLogisticsNumber', minStatus: 21 },
  { key: 'operator', labelKey: 'message.operator' },
  { key: 'inspectionDetail', labelKey: 'message.inspectionDetail' },
]
const defaultColumns = columnOptions.map(item => item.key)

export default {
  components: {
    detailHeader,
    Header,
    translateOperation,
    footerPage,
    distributionOrderSplitting,
    packingOperation,
    boxList,
    addBox,
    boxGaugeModification,
    modificationOfWeigh,
    encasement,
    cancelEncasement,
    movingGoodsBox,
    offerOperation,
    offerDistributionOrderSplitting,
    InternationalFreight,
    otherExpenses,
    toBePaidOperation,
    tagEditing,
    tagMatching,
    specialCustomerLabels,
    toBeShippedOperation,
    wuliuFillIn,
    internationalDeliveryOperation,
    wholeOrderAfterSale,
    afterSaleOfGoods,
    EMSprintingmark,
    TWCustomerShippingmark,
    TWCustomerShippingmarkNormal,
    OCSCustomerShippingmark,
    OCSShippingmark,
    DQShippingmark,
    DQCustomerShippingmark,
    requotationOfDeliveryOrder,
    PackingTabs,
    tabPrint,
    KS_JPShippingmark,
    RWCustomerShippingmark,
    tagEditNum,
    statistics,
    fbaScanList,
    inspectDetail,
    goodsTagLog,
    fbaMatchNotice,
    abandoned,
    Raku_DQShippingmark,
    batchModifyCodeType,
    printAgain,
    lookTag,
    appliedLabels,
    addServiceOrder,
    createServiceOrder,
    addGoods,
    singleProductCancellation,
    oneCancellatioBoxes,
    kitAssembly,
    inSalePreview,
    is_FBA,
    unprintedTagPrompt,
    spotCheckDetails,
    presetTask,
    columnSettingsDialog,
    assignSealerDialog,
    MaterialInfo,
    MaterialMarkTip,
  },
  metaInfo() {
    return {
      title: '配送单' + this.detail.statusName,
    };
  },
  data() {
    return {
      porder_sn: this.$route.query.porder_sn, //配送单号
      columnOptions,
      visibleColumns: [...defaultColumns],
      columnSettingsVisible: false,
      planRemarkSaving: false,
      sealerCandidates: [],
      sealerCandidatesLoading: false,
      sealerCandidatesLoaded: false,
      checked: false, //全选
      selectedList: [],
      distributionOrderSplittingDialogVisible: false,
      freightDetailData: [], //商品装箱情况
      tagData: {},
      printTagData: null,
      isExpress: '',
      fbaScanData: {
        order_detail_id: '',// 订单ID
        porder_sn: this.$route.query.porder_sn, //配送单号
        porder_detail_tag_id: '', //标签记录ID
      },
      inspectDetailList: [],//检品列表
      itemData: {},
      userRole: localStorage.getItem("japanUserRoleStatus"),
      tabPrintNum: 1,// 打印标签次数
      order_detail_tag_id: '',//标签ID
      porder_detail_tag_print: [],//历史打印
      allowedLogistics: [
        '海源DQ船便',
        'コンテナ',
        'お任せ(お勧め)',
        '電子特殊便',
        'その他',
        'FBA新幹線',
        '海源TK船便',
        '海源 LCLコンテナ混載便',
        '海源電子特殊航空便',
        'Rロジ専用船便',
      ]
    };
  },
  computed: {
    ...mapState({
      list: (state) => state.porderDetail.list,
      status: (state) => state.porderDetail.status,
      logistics: (state) => state.porderDetail.logistics, //要打印的物流方式
      printData: (state) => state.porderDetail.printData, //要打印的数据
      is_authorized: (state) => state.porderDetail.is_authorized, //要打印的数据 是都授权
      detail: (state) => state.porderDetail.detail, //全部详情
      isPack: (state) => state.porderDetail.isPack, //已装箱2
      boxList: (state) => state.porderDetail.boxList,
    }),
    // 业务、采购、财务看全部；配货只看配货；检品看检品和配货。
    visibleRequirements() {
      switch (Number(this.userRole)) {
        case 5: return ['delivery']
        case 6: return ['inspect', 'delivery']
        case 1: // 业务
        case 2: // 采购
        case 3: // 财务
        default: return ['purchase', 'inspect', 'delivery']
      }
    },
    isBusiness() {
      return Number(this.userRole) === 1
    },
    materialRows() {
      return Array.isArray(this.list) ? this.list : []
    },
    allMaterialsExpanded() {
      return this.materialRows.length > 0 && this.materialRows.every(item => item.materialExpanded)
    },
    isAmazonOrStockcrew() {
      return this.detail.is_amazon || (
        this.detail.external_inbound &&
        this.detail.external_inbound.warehouse_type === 'stockcrew'
      )
    },
    // 只向弹框提供当前配送单状态下真实存在的列。
    availableColumnOptions() {
      const status = Number(this.status)
      return this.columnOptions.filter(item => {
        if (item.statuses && !item.statuses.includes(status)) return false
        if (item.minStatus && status < item.minStatus) return false
        if (item.amazonOnly && !this.isAmazonOrStockcrew) return false
        return true
      })
    },
    // 提出数量总数
    num() {
      let num = 0;
      this.list.forEach((item) => {
        num += item.freight_num - 0;
      });
      return num;
    },
    // 小计
    subtotal() {
      let subtotal = 0;
      this.list.forEach((item) => {
        subtotal += item.freight_num * (item.confirm_price - 0);
      });
      return subtotal.toFixed(2);
    },
  },
  watch: {
    list: {
      immediate: true,
      handler(list) {
        if (!Array.isArray(list)) return
        list.forEach(item => this.initMaterialState(item))
      }
    }
  },
  created() {
    this.loadColumnSettings()
    let datas = {
      porder_sn: this.porder_sn,
      filterByFreightNum: this.userRole == 5 ? 1 : '',
      is_japanfirm: this.$route.query.is_japanfirm
    }
    this.$store.dispatch("porderDetail", datas)
    this.$store.dispatch("getLogisticsList"); //物流方式获取
    this.$store.dispatch("findAllBlockImporter"); //获取千速黑名单列表
  },

  methods: {
    // 所有状态均可调整；每次打开清空选择，候选人员成功加载后复用。
    openAssignSealer() {
      if (!this.isAuth(779) || !this.porder_sn) return
      this.$refs.assignSealerDialog.open([this.porder_sn])
      if (this.sealerCandidatesLoading || this.sealerCandidatesLoaded) return
      this.sealerCandidatesLoading = true
      this.$api.porderApi.sealingCandidates().then((res) => {
        if (res.code != 0 || res.success === false) return
        this.sealerCandidates = res.data
        this.sealerCandidatesLoaded = true
      }).catch(() => {
        // 错误由公共请求层提示，下次打开时可重新加载。
      }).finally(() => {
        this.sealerCandidatesLoading = false
      })
    },
    // 调整成功后仅刷新当前配送单，保留详情原有的工种筛选参数。
    refreshSealerDetail() {
      this.$store.dispatch('porderDetail', {
        porder_sn: this.porder_sn,
        filterByFreightNum: this.userRole == 5 ? 1 : '',
        is_japanfirm: this.$route.query.is_japanfirm,
      })
    },
    initMaterialState(item) {
      if (item.materialExpanded === undefined) {
        this.$set(item, 'materialExpanded', shouldExpandPlanRemark(item, this.visibleRequirements, this.isBusiness))
      }
      if (item._planRemarkSnapshot === undefined) {
        this.$set(item, '_planRemarkSnapshot', getPlanRemarkSnapshot(item))
      }
    },
    toggleMaterial(item) {
      this.initMaterialState(item)
      item.materialExpanded = !item.materialExpanded
    },
    toggleAllMaterials() {
      const expanded = !this.allMaterialsExpanded
      this.materialRows.forEach(item => {
        this.initMaterialState(item)
        item.materialExpanded = expanded
      })
    },
    // 有勾选时批量保存当前要求；无勾选时仅保存当前商品，沿用业务编辑权限。
    async savePlanRemark(item, col) {
      if (!this.isBusiness || this.planRemarkSaving) return
      const remark = normalizePlanRemark(item[col])
      if (item._planRemarkSnapshot && item._planRemarkSnapshot[col] === remark) return

      const selectedList = this.materialRows.filter(row => row.checked)
      const list = selectedList.length ? selectedList : [item]
      if (!list.includes(item)) {
        item[col] = item._planRemarkSnapshot ? item._planRemarkSnapshot[col] : ''
      }
      const changedList = list.filter(row => !row._planRemarkSnapshot || row._planRemarkSnapshot[col] !== remark)
      if (!changedList.length) return
      // 使用订单明细 ID 去重，一次请求完成批量修改。
      const orderDetailIds = [...new Set(changedList.map(row => row.order_detail_id))]

      this.planRemarkSaving = true
      try {
        const res = await this.$api.orderApi.updatePlanRemark({
          order_detail_id: orderDetailIds,
          col,
          remark,
        }, { isLoading: true, resolveError: true })
        if (res.code != 0 || res.success === false) {
          item[col] = item._planRemarkSnapshot ? item._planRemarkSnapshot[col] : ''
          return
        }
        // 同一订单明细可能重复展示；成功后同步对应行，不改其他商品或要求。
        this.materialRows.filter(row => orderDetailIds.includes(row.order_detail_id)).forEach(row => {
          this.$set(row, col, remark)
          if (!row._planRemarkSnapshot) this.$set(row, '_planRemarkSnapshot', getPlanRemarkSnapshot(row))
          row._planRemarkSnapshot[col] = remark
          this.$set(row, 'materialExpanded', true)
        })
        this.$message.success(res.msg)
      } catch (error) {
        item[col] = item._planRemarkSnapshot ? item._planRemarkSnapshot[col] : ''
        // 失败提示由公共请求层处理，未保存行保持原值。
      } finally {
        this.planRemarkSaving = false
      }
    },
    // 配送单接口的辅料记录外层包含 consume，主档字段在 material 内，转换成公共组件需要的平铺结构。
    getMaterialInfoList(item) {
      return (Array.isArray(item.material_bind) ? item.material_bind : []).map(binding => ({
        ...binding.material,
        // 外层绑定 ID 不参与库位查询，主档 ID 来自关联字段或辅料详情。
        material_id: binding.material_id || (binding.material && binding.material.id),
        consume: binding.consume
      }))
    },
    // 按账号保存详情页表头配置。
    getColumnStorageKey() {
      let userId = 'default'
      try {
        const userInfo = JSON.parse(localStorage.getItem('japanUserRoleInfo') || '{}')
        userId = userInfo.id || 'default'
      } catch (error) {
        userId = 'default'
      }
      return `porderDetail:columnConfig:v1:${userId}`
    },
    // 配置不存在或损坏时默认显示全部字段，新增字段也默认显示。
    loadColumnSettings() {
      try {
        const savedConfig = JSON.parse(localStorage.getItem(this.getColumnStorageKey()) || '{}')
        if (savedConfig.columns) {
          this.visibleColumns = defaultColumns.filter(key => savedConfig.columns[key] !== false)
        }
      } catch (error) {
        // 本地配置损坏时使用默认展示方案
      }
    },
    isColumnVisible(key) {
      return this.visibleColumns.includes(key)
    },
    saveColumnSettings(selectedColumns) {
      const availableKeys = this.availableColumnOptions.map(item => item.key)
      // 只更新当前状态提供的字段，其他状态专属字段保留原配置。
      this.visibleColumns = defaultColumns.filter(key => {
        return availableKeys.includes(key)
          ? selectedColumns.includes(key)
          : this.visibleColumns.includes(key)
      })
      const columns = defaultColumns.reduce((result, key) => {
        result[key] = this.visibleColumns.includes(key)
        return result
      }, {})
      localStorage.setItem(this.getColumnStorageKey(), JSON.stringify({
        version: 1,
        columns,
      }))
    },
    // 单选
    Single() {
      this.selectedList = [];
      this.list.forEach((item) => {
        if (item.checked) {
          this.selectedList.push(item);
        }
      });
      this.checked = this.list.every((item) => item.checked);
    },
    //全选
    allChecked() {
      this.selectedList = [];
      this.list.forEach((item) => {
        item.checked = this.checked;
        if (item.checked) {
          this.selectedList.push(item);
        }
      });
      this.$forceUpdate();
    },
    //查看单番装箱信息
    sortingBoxDetail(porder_detail_id) {
      this.$api.porderApi.sortingBoxDetail({ porder_detail_id }).then((res) => {
        this.freightDetailData = res.data;
      });
    },
    //标签编辑
    tagEditing(tag) {
      this.tagData = JSON.parse(JSON.stringify(tag));
      this.$refs.tagEditing.dialogVisible = true;
    },
    //标签只编辑数量
    tagEditNum(tag) {
      this.tagData = JSON.parse(JSON.stringify(tag));
      this.$refs.tagEditNum.dialogVisible = true;
    },
    //标签打印
    fbaPrint(tag, type, is_print) {
      this.printTagData = tag;
      this.isExpress = type

      if (this.userRole != 6) {
        this.tabPrintNum = 1
        this.$nextTick(() => {
          this.$print(this.$refs.tabPrint);
          this.printTagData = null;
          this.$forceUpdate();
        });
        return false //不是检品打印，不算打印  
      }
      // 未 打印
      if (!is_print) {
        let datas = {
          order_detail_tag_id: tag.id,
        };
        this.tabPrintNum = 1
        this.$nextTick(() => {
          this.$print(this.$refs.tabPrint);
          this.printTagData = null;
          this.$forceUpdate();
        })
        this.$api.porderApi.fbaPrint(datas).then((res) => {
          // 修改打印完的状态
          this.list.forEach(item => {
            item.porder_detail_tag.forEach(tags => {
              if (tags.id == tag.id) {
                tags.is_print = 1
              }
            })
          })
          this.$forceUpdate();
          // this.$store.dispatch("porderDetail", {
          //   porder_sn: this.porder_sn,
          // });

        });
      } else {
        // this.$print(this.$refs.tabPrint);
        // this.printTagData = null;
        this.order_detail_tag_id = tag.id + ''
        this.$refs.printAgain.dialogVisible = true
      }
      // 已打印的

    },
    //标签删除
    deleteFbaSign(tag) {
      this.$confirm(
        this.$t("message.areYouSureToDelete"),
        this.$t("message.prompt"),
        {
          confirmButtonText: this.$t("message.ok"),
          cancelButtonText: this.$t("message.cancel"),
          type: "warning",
          center: true,
        }
      )
        .then(() => {
          let datas = {
            order_detail_tag_id: tag.id,
          };
          this.selectedList
          this.$api.porderApi.deleteTag(datas).then((res) => {
            this.$message.success(res.msg);
            this.$store.dispatch("porderDetail", { porder_sn: this.porder_sn });
          });
        })
        .catch(() => { });
    },
    //批量修改
    allEdit(val, type, checked) {
      if (checked) {
        this.list.forEach(item => {
          if (item.checked) {
            item[type] = val
          }
        })
      }
    },
    // 标签核对
    labelCheck(order_detail_id, id) {
      this.fbaScanData.order_detail_id = order_detail_id
      this.fbaScanData.porder_detail_tag_id = id
      this.$refs.fbaScanList.dialogVisible = true;
    },
    //检品详情
    purchaseInspectDetail(item) {
      let datas = {
        order_purchase_ids: item.order_purchase_ids
      }
      this.$api.followApi.purchaseInspectDetail(datas).then(res => {
        this.inspectDetailList = res.data[0].inspect_detail
        this.$refs.inspectDetail.dialogVisible = true
      })
    },
    // 历史标签
    historyTag(item) {
      this.itemData = item
      this.$refs.goodsTagLog.dialogVisible = true
    },
    //配送单-修改单番商品备注
    updateDetailRemark(item) {
      let datas = {
        list: []
      }
      if (item.checked) {
        this.list.forEach(items => {
          if (items.checked) {
            datas.list.push(
              {
                porder_sn: this.porder_sn,
                porder_detail_id: items.id,
                col: 'y_remark',
                value: item.y_remark
              }
            )
          }
        })
      } else {
        datas.list.push(
          {
            porder_sn: this.porder_sn,
            porder_detail_id: item.id,
            col: 'y_remark',
            value: item.y_remark
          })
      }
      this.$api.porderApi.updateDetailRemark(datas).then(res => {
        this.$message.success(res.msg)
      })
    },
    // 查看历史 打印
    lookTag(porder_detail_tag_print) {
      this.porder_detail_tag_print = porder_detail_tag_print
      this.$refs.lookTag.dialogVisible = true
    },
    //新建标签
    labelNumberAdd(item) {

      this.tagData = {
        porder_detail_id: "",
        type: "FBA",
        no: "",
        goods_no: "",
        num: item.num,
        code_type: "CODE128",
        text_line_one: "",
        text_line_two: "",
        porder_detail_id: item.id,
        isAdd: true,
      };
      this.$refs.tagEditing.dialogVisible = true;
    },
    //显示番
    getSorting(set_detail_id) {
      let itemData = this.list.find(item => item.order_detail_id == set_detail_id)
      return itemData ? itemData.sorting : '无'
    },
    // 售中问题产品提出成功
    problemStoreSuccess() {
      this.$store.dispatch("porderDetail", { porder_sn: this.porder_sn, })
    },
    // 是否输入的小数
    handleInput(value, index, item) {
      // 使用正则表达式来判断是否输入了小数
      const regex = /^(\d+)?(\.\d{1,2})?$/;
      if (!regex.test(value)) {
        // 如果输入的不是小数，则将其设置为上一次的值
        this.list[index].received_num = this.list[index].received_num.replaceAll('.', '');
        this.list[index].received_num = this.list[index].received_num.replaceAll('-', '');
        this.list[index].received_num = this.list[index].received_num.replace(/[^\d^]+/g, "") // 第二步：把不是数字，不是小数点的过滤掉
      }
      if (item.received_num > item.planned_num) {
        this.list[index].received_num = item.planned_num
      }
    },
    // 修改实际纳品数
    updateDeliveryNumber(item) {
      let datas = {
        porder_sn: this.porder_sn,
        porder_detail_id: item.id,
        received_num: item.received_num
      }
      this.$api.porderApi.updateDeliveryNumber(datas).then(res => {
        this.$message.success(res.msg)
      })
    },
    // 配送单详情库位：区域用途编码 + “】-”后的完整库位编号 + 出货数量。
    fromGrids(item) {
      return `${getAreaGridName(item.area_type_code, item.grid_number)} ${item.num}个`
    }
  },
};
</script>
<style lang="scss" scoped>
/deep/.el-checkbox__inner {
  transform: scale(2) !important;
}

.detail {
  .orderDetail {
    .table {
      // 番号列左上角的辅料标识
      .materialMarkTip {
        position: absolute;
        top: -8px;
        left: 0;
        z-index: 2;
      }

      // 与订单详情展开按钮样式保持一致
      .materialToggle {
        position: static;
        flex: none;
        align-self: flex-start;
        margin-top: auto;
        // 配送单辅料展开按钮颜色与检品列表保持一致。
        min-width: 56px;
        height: 24px;
        padding: 0 6px;
        border: 0;
        border-radius: 4px;
        background-color: #ecf5ff;
        color: #409eff;

        &:hover,
        &:focus {
          background-color: #ecf5ff;
          color: #409eff;
        }

        i {
          margin-left: 2px;
          font-size: 12px;
        }
      }

      // 左右等宽；辅料卡片超宽时只滚动左侧，右侧按可见要求数排版。
      .materialRequirements {
        display: flex;
        gap: 24px;
        min-width: 0;
        padding: 16px 20px;
        border-bottom: 1px solid #dcdfe6;
        background-color: #fff;
      }

      .materialRequirementsList,
      .materialRequirementsRemarks {
        flex: 1 1 0;
        min-width: 0;
      }

      .materialRequirementsList {
        /deep/ .material-info-panel {
          padding: 0;
          border: 0;
        }

        /deep/ .material-list {
          display: flex;
          overflow-x: auto;
          padding: 10px 10px 8px 0;
        }

        /deep/ .material-card {
          flex: 0 0 288px;
        }

        /deep/ .empty {
          display: flex;
          align-items: center;
          justify-content: center;
          height: 136px;
          padding: 0;
        }
      }

      .materialRequirementsRemarks {
        display: grid;
        grid-template-columns: repeat(3, minmax(0, 1fr));
        gap: 16px;

        &.doubleRequirement {
          grid-template-columns: repeat(2, minmax(0, 1fr));
        }

        &.singleRequirement {
          grid-template-columns: minmax(0, 1fr);
        }
      }

      .requirementItem {
        display: flex;
        flex-direction: column;
        min-width: 0;

        label {
          display: block;
          margin-bottom: 10px;
          color: #333;
          font-size: 14px;
          font-weight: bold;
        }

        /deep/ .el-textarea {
          display: flex;
          flex: 1;
        }

        /deep/ .el-textarea__inner {
          flex: 1;
          min-height: 96px !important;
          height: auto !important;
        }
      }

      li {
        /deep/.el-textarea__inner {
          min-height: 100px !important;
          padding: 5px;
        }
      }

      ul {
        .selectCell,
        .flex05 {
          overflow: visible;
        }

        li {
          overflow: hidden;
        }

      }
    }

    .entry-code {
      color: #000;
      font-weight: 700;
    }
  }
}

.operate {
  position: sticky;
  bottom: 0;
  left: 0;
  z-index: 210;
  width: 100%;
  box-sizing: border-box;
  background-color: #edeff4;
}

/deep/.has-gutter {
  th {
    padding: 8px 0;
  }
}

.putForwardNum /deep/.el-input__inner {
  padding: 0;
  text-align: center;
}

.tips {
  width: 100%;
  background-color: #b4272d;
  color: #fff;
}

.abnormal {
  color: #b4272d;
  font-weight: bold;
  font-size: 18px;
}

.inSale {
  position: relative;

  .wen {
    position: absolute;
    top: -55px;
    left: 0px;
    width: 24px;
    height: 24px;
    background: #c60524;
    border-radius: 12px;
    text-align: center;
    line-height: 24px;
    color: #fff;
  }
}

.el-icon-question {
  font-size: 14px;
  cursor: pointer;
  color: #666;
}

/deep/.el-textarea__inner {
  height: 150px !important;
}

// 配送单详情列表视觉优化：仅调整布局和样式，不改变原有列、状态及操作逻辑。
.detail {
  // 跟随头部 1862px 内容宽度和两侧 24px 内边距完整铺开。
  min-width: 1910px;
  min-height: 100vh;
  word-break: break-all;
  background-color: #f5f7fa;

  .detailToolbar {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 16px;
    min-height: 64px;
    margin: 16px 20px 0;
    padding: 10px 16px;
    border: 1px solid #e4e7ed;
    border-bottom: 0;
    border-radius: 8px 8px 0 0;
    background-color: #fff;
    box-sizing: border-box;

    /deep/ .PackingTabs {
      flex: 1 1 auto;
      min-width: 0;
      margin: 0 !important;

      .el-tabs__header {
        margin: 0;
      }

      .el-tabs__content {
        display: none;
      }
    }

    .column-settings-bar {
      display: flex;
      flex: none;
      align-items: center;
      justify-content: flex-end;
      gap: 8px;
      margin-left: auto;

      .el-button {
        margin: 0;
      }
    }
  }

  .orderDetail {
    position: relative;
    overflow: visible;
    margin: 0 20px 24px;
    padding: 0;
    border: 1px solid #e4e7ed;
    border-radius: 0 0 8px 8px;
    background-color: #fff;
    box-shadow: 0 2px 10px rgba(31, 45, 61, 0.06);

    .table {
      // 列表按内容自然撑高，表头相对页面滚动保持吸顶。
      font-size: 13px;
      line-height: 1.5;
      background-color: #fff;

      ol,
      ul {
        width: 100%;
        min-width: 100%;
        box-sizing: border-box;
      }

      ol {
        position: sticky;
        top: 0;
        left: 0;
        z-index: 200;
        height: 52px;
        line-height: normal;
        border-bottom: 1px solid #dcdfe6;
        border-radius: 0;
        background-color: #eef1f6;
        box-shadow: 0 2px 6px rgba(31, 45, 61, 0.08);

        li {
          height: 52px;
          color: #303133;
          font-weight: 600;
          text-align: center;
        }

        // 客户配送单商品备注沿用提示背景，文字颜色与其他备注列保持一致。
        .customerDeliveryNoteHeader {
          background-color: #fef0f0;
          color: #303133;
          font-size: 13px;
          font-weight: 600;
        }
      }

      // 客户配送单商品备注正文使用普通黑色，并从单元格左上角开始展示。
      .customerDeliveryNoteCell {
        align-items: flex-start;
        justify-content: flex-start;
        background-color: #fff;
        color: #303133;
        font-size: 13px;
        font-weight: 400;
        line-height: 1.6;
        text-align: left;
        white-space: pre-wrap;
        word-break: break-word;
      }

      // 三个备注列使用相同比例加宽，表头和正文保持对齐。
      .remarkColumn {
        flex: 1.5 1 0;
      }

      li {
        flex: 1 1 0;
        width: auto;
        min-width: 0;
        margin-right: 0;
        padding: 12px 10px;
        border-right: 1px solid #ebeef5;
        box-sizing: border-box;

        &:last-child {
          border-right: 0;
        }
      }

      .flex05 {
        flex: 0.55 1 0;
      }

      .no-column {
        flex: 0.75 1 0;
      }

      .orderNumberColumn {
        flex: 0.95 1 0;
        flex-direction: column;
        align-items: center !important;
        justify-content: flex-start;
        gap: 8px;
        text-align: center;

        .orderNumberLink {
          color: #409eff;
          overflow-wrap: anywhere;
          word-break: normal;
        }

        .kitAssemblyBadge {
          display: inline-flex;
          align-items: center;
          justify-content: center;
          max-width: 100%;
          min-height: 24px;
          padding: 2px 6px;
          border: 1px solid;
          border-radius: 4px;
          font-size: 12px;
          font-weight: 600;
          line-height: 18px;
          cursor: pointer;
          box-sizing: border-box;
          word-break: keep-all;
        }

        .kitAssemblyMain {
          border-color: #f56c6c;
          background-color: #fef0f0;
          color: #b4272d;
        }

        .kitAssemblyBundle {
          border-color: #67c23a;
          background-color: #f0f9eb;
          color: #67c23a;
        }
      }

      .commodityPropertiesColumn {
        flex: 0.9 1 0;
      }

      .pictureColumn {
        flex: 0.75 1 0;
      }

      .tagNumberColumn {
        flex: 3 1 0;
      }

      .labelImportQuantityColumn {
        flex: 1.15 1 0;

        .template {
          display: flex;
          flex-direction: column;
          align-items: center;
          gap: 12px;
          text-align: center;

          p,
          .el-button {
            margin: 0 !important;
          }
        }

        .tagMatchCount {
          display: inline-flex;
          align-items: center;
          justify-content: center;
          min-height: 28px;
          padding: 4px 10px;
          border: 1px solid #e4e7ed;
          border-radius: 5px;
          background-color: #fff;
          color: #606266;
          font-weight: 600;
          box-sizing: border-box;

          &.bacRed {
            border-color: #fbc4c4;
            background-color: #fef0f0;
            color: #f56c6c;
          }
        }
      }

      // 装箱和检品详情列统一轻微收窄。
      .compactColumn {
        flex: 0.8 1 0;
      }

      // 配送单汇总信息从左侧排列，并突出数量和费用数据。
      .deliveryTotals {
        justify-content: flex-start;
        gap: 56px;
        padding: 0 20px;

        li {
          flex: 0 0 auto;
          width: auto;
          min-width: 0;
          padding: 16px 0;
          border-right: 0;
          color: #b4272d;
          font-size: 18px;
          font-weight: 700;
          line-height: 1.5;
          text-align: left;
          white-space: nowrap;
        }
      }

      .quantityColumn {
        flex: 1.35 1 0;

        // 沿用原库存数量判断，仅将提出数警示改为浅橙提示样式。
        .putForwardNum.stockTotal {
          display: inline-flex;
          align-items: center;
          gap: 4px;
          width: auto;
          max-width: 100%;
          margin-bottom: 6px;
          padding: 5px 6px;
          border: 1px solid #ffd2b8;
          border-radius: 6px;
          background-color: #fff1e8;
          color: #f56c2d;
          font-size: 13px;
          font-weight: 600;
          white-space: nowrap;
          box-sizing: border-box;

          span {
            display: inline-flex;
            align-items: center;
            flex-wrap: nowrap;
            gap: 4px;
            min-width: 0;
            white-space: nowrap;
          }

          /deep/ .el-input__inner {
            background-color: #fff;
          }
        }
      }

      // 仅将商品管理袋子图标固定在番号单元格左上角，其他标识维持原布局。
      .sortingColumn {
        position: relative;

        .sorting {
          position: static;
          width: 100%;
          min-width: 0;
          text-align: center;
        }

        .claim {
          position: absolute;
          top: 8px;
          left: 8px;
          z-index: 2;
          margin: 0;

          i {
            color: #b4272d;
            font-size: 20px;
          }
        }

        // 禁品图标跟随番号内容向下排列，不再使用越过单元格的负值定位。
        .contraband {
          position: static;
          top: auto;
          right: auto;
          margin-top: 8px;

          img {
            width: 30px;
          }
        }
      }

      .flex15 {
        flex: 1.5 1 0;
      }

      .flex2 {
        flex: 2 1 0;
      }

      .porderGoodsGroup {
        > ul {
          align-items: stretch;
          padding: 0;
          border-bottom: 1px solid #dcdfe6;
          background-color: #fff;

          > li {
            min-height: 180px;
            align-items: flex-start;
            padding-top: 16px;
            padding-bottom: 16px;
          }

          &:hover {
            background-color: #f7fbff;
          }
        }

        &:nth-of-type(even) > ul {
          background-color: #fafbfd;
        }

        > ul.tagSame {
          background-color: #fff189;
        }
      }

      .selectCell {
        flex-direction: column;
        align-items: flex-start;
        justify-content: flex-start;
        gap: 12px;
        padding-right: 8px;
        padding-left: 8px;

        .noTopRow {
          display: flex;
          flex: none;
          align-items: center;
          justify-content: flex-start;
          gap: 12px;
          width: 100%;
          min-height: 30px;

          b {
            display: inline-flex;
            align-items: center;
            font-weight: 500;
          }
        }

        .noSelection {
          display: flex;
          flex: none;
          align-items: center;
          justify-content: center;
          width: 28px;
        }

        .noStatusArea {
          display: flex;
          flex: 1 1 auto;
          flex-direction: column;
          align-items: flex-start;
          width: 100%;
          min-height: 0;
        }

        .noBadgeRow {
          display: flex;
          align-items: center;
          justify-content: flex-start;
          flex-wrap: wrap;
          gap: 8px;
          width: 100%;

          .inSale,
          .wen {
            position: static;
          }

          .wen {
            display: inline-flex;
            align-items: center;
            justify-content: center;
            flex: none;
          }
        }
      }

      .template,
      .attribute {
        width: 100%;
        line-height: 1.6;
        text-align: left;
      }

      .attribute {
        padding: 0 4px;
        box-sizing: border-box;
      }

      .tags {
        width: 100%;
        margin-bottom: 8px;
        padding: 6px;
        border: 0;
        border-radius: 4px;
        background-color: #fff;
        box-shadow: 0 1px 4px rgba(31, 45, 61, 0.06);
        font-size: 12px;
        box-sizing: border-box;

        &:last-child {
          margin-bottom: 0;
        }

        .tagActions {
          display: flex;
          align-items: center;
          flex-wrap: wrap;
          gap: 6px;
          padding-bottom: 8px;

          .el-button {
            margin: 0;
          }

          .tagPrint {
            margin-left: auto;
          }
        }

        .tagRecord {
          width: 100%;
          border: 1px solid #dcdfe6;
          border-radius: 2px;
          box-sizing: border-box;
        }

        .tagField {
          display: flex;
          align-items: stretch;
          min-height: 30px;
          border-bottom: 1px solid #ebeef5;

          &:last-child {
            border-bottom: 0;
          }
        }

        .tagLabel,
        .tagValue {
          display: flex;
          align-items: center;
          padding: 4px 6px;
          box-sizing: border-box;
        }

        .tagLabel {
          flex: 0 0 36%;
          border-right: 1px solid #ebeef5;
          background-color: #f5f7fa;
          color: #606266;
          white-space: nowrap;
        }

        .tagValue {
          flex: 1 1 0;
          min-width: 0;
          background-color: #fff;
          color: #606266;
          text-align: left;
          overflow-wrap: anywhere;
          word-break: normal;
        }

        .tagCountValue {
          justify-content: space-between;
          gap: 8px;

          > span,
          .el-button {
            flex: none;
            white-space: nowrap;
          }
        }

        .barcodeIcon {
          flex: none;
          width: 25px;
          margin-left: 5px;
        }
      }

    }
  }
}

</style>
